<template>
  <main class="dashboard-page afro-bg">
    <section class="dashboard-shell paper-panel">
      <header class="dash-head">
        <div>
          <p class="eyebrow">Panel Juliam Arcade</p>
          <h1>Bienvenido</h1>
          <span>{{ isAdmin ? 'Gestión del menú, recetario y usuarios internos.' : 'Consulta tu wallet, puntos y menú digital.' }}</span>
        </div>
        <div class="dash-brand" aria-label="Juliam Arcade"><span>J</span><strong>ARCADE</strong></div>
      </header>

      <div class="dash-grid">
        <router-link class="dash-card wallet" to="/wallet">
          <b>Mi wallet</b>
          <span>Consulta puntos, QR de cliente, tickets y canjes.</span>
        </router-link>
        <router-link v-if="isAdmin" class="dash-card" to="/recetas">
          <b>Recetario</b>
          <span>Consulta recetas por categoria y producto.</span>
        </router-link>
        <router-link v-if="$canView('administrador','superadministrador')" class="dash-card" to="/catalogo">
          <b>Catálogo</b>
          <span>Edita categorías, precios, activos, orden y recetas.</span>
        </router-link>
        <router-link class="dash-card" to="/menu" target="_blank">
          <b>Menú digital</b>
          <span>Abre la vista horizontal para monitor o la versión responsive para celular.</span>
        </router-link>
        <router-link v-if="$canView('administrador','superadministrador')" class="dash-card" to="/usuarios">
          <b>Usuarios</b>
          <span>Administra accesos y permisos.</span>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'HomeView',
  computed: {
    isAdmin() {
      return ['administrador', 'superadministrador'].includes(this.$store.state.role)
    }
  }
}
</script>

<style scoped>
.dashboard-page { min-height: 100vh; width: 100%; padding: 28px; }
.dashboard-shell { width: min(1100px, 100%); margin: 0 auto; padding: 28px; }
.dash-head { display: flex; justify-content: space-between; align-items: center; gap: 20px; text-align: left; border-bottom: 1px solid var(--juliam-line); padding-bottom: 22px; }
.dash-brand { display: flex; align-items: center; gap: 11px; }
.dash-brand span { width: 58px; height: 58px; display: grid; place-items: center; border: 2px solid var(--juliam-cyan); color: var(--juliam-pink); font: 900 31px/1 var(--juliam-mono); box-shadow: 0 0 18px rgba(76,245,255,.25); }
.dash-brand strong { color: var(--juliam-cyan); font: 900 18px/1 var(--juliam-mono); letter-spacing: .12em; }
.eyebrow { margin: 0 0 8px; color: var(--juliam-lime); font: 900 10px/1 var(--juliam-mono); text-transform: uppercase; letter-spacing: .16em; }
h1 { margin: 0; color: var(--juliam-text); font-family: var(--juliam-sans); font-size: clamp(42px, 6vw, 72px); letter-spacing: -.055em; text-transform: uppercase; }
.dash-head span { color: var(--juliam-muted); font-weight: 600; }
.dash-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; margin-top: 24px; }
.dash-card { min-height: 170px; border: 1px solid rgba(255,255,255,.11); border-radius: 14px; background: rgba(5,8,19,.55); padding: 22px; text-align: left; text-decoration: none; color: var(--juliam-text); display: flex; flex-direction: column; justify-content: flex-end; transition: transform .18s ease, border-color .18s ease, background .18s ease; }
.dash-card:nth-child(2n) { border-top-color: rgba(255,63,216,.48); }
.dash-card:hover { transform: translateY(-3px); border-color: var(--juliam-cyan); background: rgba(76,245,255,.06); }
.dash-card b { color: var(--juliam-cyan); font-family: var(--juliam-sans); font-size: 30px; letter-spacing: -.035em; text-transform: uppercase; }
.dash-card span { color: var(--juliam-muted); font-weight: 600; margin-top: 8px; line-height: 1.5; }
@media (max-width: 760px) { .dashboard-page { padding: 0; } .dashboard-shell { border-radius: 0; padding: 18px; } .dash-head { flex-direction: column; align-items: flex-start; } .dash-grid { grid-template-columns: 1fr; } }
</style>
